import { cx } from './ui';
import { SCALES, setDisplayScale, useDisplayScale } from '../state/displayScale';

/** Segmented control for the whole-app display scale — for reading at a distance. */
export function DisplaySizeSwitcher() {
  const scale = useDisplayScale();

  return (
    <div
      role="radiogroup"
      aria-label="Display size"
      className="inline-flex items-center gap-0.5 rounded-md border border-border-subtle bg-surface p-0.5"
    >
      {SCALES.map((o) => {
        const active = scale === o.value;
        return (
          <button
            key={o.value}
            role="radio"
            aria-checked={active}
            onClick={() => setDisplayScale(o.value)}
            className={cx(
              'h-9 rounded-[5px] px-3 font-mono text-[12px] transition-colors',
              active
                ? 'bg-[var(--color-accent-dim)] text-accent'
                : 'text-muted hover:bg-surface-high hover:text-secondary',
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
